import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const contractParamsSchema = object({
  contractId: stringToNumber()
})
